import { ICellRendererParams } from 'ag-grid-community'

import React from 'react'
import draftToHtml from 'draftjs-to-html'
import { isJSON } from '@/utils'

export function HtmlRenderer(params: ICellRendererParams) {
  const { value } = params

  const getRestStateText = (value: string) => {
    if (isJSON(value)) {
      return draftToHtml(JSON.parse(value))
    } else if (!value || value.startsWith('<p></p>')) {
      return '-'
    }

    return value
  }

  return (
    <>
      {value ? (
        <div
          className='cursor-pointer'
          dangerouslySetInnerHTML={{
            __html: getRestStateText(value),
          }}
        />
      ) : (
        <div>-</div>
      )}
    </>
  )
}
